require('intersection-observer');
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
export default function () {

    let pixelRatio = window.devicePixelRatio;

    function loadPic(element){

        let picSrc = element.getAttribute('data-bg-image');

        if (pixelRatio > 1.5 && element.getAttribute('data-bg-image2x')) {
            picSrc = element.getAttribute('data-bg-image2x');
        }

        element.classList.add('loading');

        if (element.getAttribute('data-img') == "1") {
            let imgItem = element.getElementsByTagName('img')[0];

            imgItem.src = picSrc;

            imgItem.onload = function () {
                element.classList.remove('loading');
                element.classList.add('loaded');
            };

        }
        else {
            /*
            $('<img/>').attr('src', picSrc).on('load', function () {
                $(this).remove();
                element.css('background-image', 'url(' + picSrc + ')');
                element.addClass('loaded').removeClass('loading');
            });*/
        }
    }

    if (IntersectionObserver) {
        //When the element is visible on the viewport,
        //add the animated class so it creates the animation.
        let callback = function(entries) {
            entries.forEach(entry => {
                //if the element is visible, add the animated class
                if (entry.isIntersecting &&
                    !entry.target.classList.contains('loaded') &&
                    !entry.target.classList.contains('loading')) {
                    loadPic(entry.target);
                }
            });
        };

        //Create the observer
        let observer = new IntersectionObserver(callback, {
            root: null,
            threshold: 0.3
        });

        //Get and observe all the items with the item class
        let items = document.querySelectorAll('.js-img-load');
        items.forEach((item) => {
            observer.observe(item);
        });
    }

}
